import { FileEntity, IFileDto } from '@/shared/interfaces';

export const mapIFileDto2FileEntity = (files: IFileDto[]): FileEntity[] => {
    if (!files || files.length === 0) {
        return [];
    }

    return files.map((file) => ({
        identifier: file.UID,
        file: new File([], file.FileName),
        fileName: file.FileName,
        isUploaded: true,
        isPending: false,
        s3Key: file.FileUrl || '',
        isFailed: false,
        guid: file.UID,
        fileSizeBytes: file.FileByteSize,
    }));
};
